import { EmptyStateController } from './empty-state.controller'

/* @ngInject */
function emptyState () {
  return {
    restrict: 'E',
    scope: {
      image: '@',
      emptyStateTitle: '@',
      message: '@',
      secondMessage: '@',
      button: '<',
      secondButton: '<',
      dropdown: '<'
    },
    templateUrl: '/core/directives/empty-state/empty-state-directive.html?$$REVISION$$',
    controller: EmptyStateController
  }
}

export { emptyState }
